import { carouselItems } from '@/mocks/home';

const carouselImages = [
  'https://readdy.ai/api/search-image?query=Deep%20investigation%20entertainment%20news%20abstract%20illustration%2C%20warm%20dark%20background%20with%20coral%20accents%2C%20magazine%20cover%20style%2C%20editorial%20design%2C%20dramatic%20lighting%2C%20entertainment%20scandal%20concept%2C%20professional%20newsroom%20aesthetic%2C%20modern%20clean%20composition&width=1200&height=600&seq=carousel-718-01&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20television%20show%20secrets%20abstract%20illustration%2C%20warm%20amber%20and%20dark%20tones%2C%20investigative%20journalism%20theme%2C%20editorial%20style%2C%20dramatic%20atmosphere%2C%20entertainment%20industry%20concept%2C%20modern%20clean%20design&width=1200&height=600&seq=carousel-718-02&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Fake%20news%20detection%20guide%20abstract%20illustration%2C%20warm%20dark%20background%20with%20secondary%20teal%20accents%2C%20educational%20editorial%20style%2C%20magnifying%20glass%20concept%2C%20modern%20clean%20composition%2C%20professional%20newsroom%20vibe&width=1200&height=600&seq=carousel-718-03&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Celebrity%20profile%20spotlight%20abstract%20illustration%2C%20warm%20dark%20background%20with%20coral%20and%20gold%20accents%2C%20magazine%20portrait%20style%2C%20entertainment%20industry%20theme%2C%20dramatic%20lighting%2C%20modern%20editorial%20design&width=1200&height=600&seq=carousel-718-04&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Live%20streaming%20industry%20crisis%20timeline%20abstract%20illustration%2C%20warm%20dark%20background%20with%20amber%20highlights%2C%20breaking%20news%20concept%2C%20editorial%20style%2C%20dramatic%20atmosphere%2C%20modern%20clean%20composition&width=1200&height=600&seq=carousel-718-05&orientation=landscape',
];

const tagColorMap: Record<string, string> = {
  '深度专题': 'bg-primary-500 text-background-50',
  '独家扒皮': 'bg-accent-500 text-background-50',
  '吃瓜指南': 'bg-secondary-500 text-background-50',
  '人物聚焦': 'bg-primary-500 text-background-50',
  '热点追踪': 'bg-accent-500 text-background-50',
};

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
              焦点专题
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto leading-relaxed">
              深度专题报道，全方位吃透每个热点事件
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-6">
            {carouselItems.map((item, i) => (
              <article
                key={i}
                className={`group flex flex-col bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer ${
                  i === 0 ? 'lg:col-span-2 lg:flex-row' : ''
                }`}
              >
                <div className={`relative overflow-hidden bg-background-200 ${
                  i === 0 ? 'lg:w-[45%] aspect-[16/9] lg:aspect-auto' : 'w-full aspect-[16/9]'
                }`}>
                  <img
                    src={carouselImages[i]}
                    alt={item.title}
                    title={`黑料718 - ${item.title}`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  {i === 0 && (
                    <div className="absolute inset-0 bg-gradient-to-r from-transparent to-black/20 pointer-events-none lg:hidden"></div>
                  )}
                </div>
                <div className={`flex flex-col justify-center p-5 md:p-6 ${i === 0 ? 'lg:flex-1' : ''}`}>
                  <span className={`inline-block text-xs font-medium px-2.5 py-1 rounded-full mb-3 self-start whitespace-nowrap ${tagColorMap[item.tag] || 'bg-background-200 text-foreground-600'}`}>
                    {item.tag}
                  </span>
                  <h3 className="text-lg md:text-xl font-semibold text-foreground-900 mb-3 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed mb-4 line-clamp-2">
                    {item.desc}
                  </p>
                  <div className="flex items-center text-xs text-foreground-400">
                    <i className="ri-eye-line mr-1"></i>
                    <span>{item.reads} 阅读</span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}